import React from "react";

// Segmented priority score bar — Urgency (max 50) / Money (max 30) / Client (max 20)
// Signature UI element (spec §8): ranking must be auditable at a glance.
export default function PriorityScoreBar({ task, showLabels = false, height = 8 }) {
  const u = task.urgency_component ?? 0; // 0..50
  const m = task.money_component ?? 0;   // 0..30
  const c = task.client_component ?? 0;  // 0..20
  const total = task.priority ?? Math.round(u + m + c);

  const seg = (val, color, label) => (
    <div
      className="h-full transition-all duration-300 group relative"
      style={{ width: `${val}%`, backgroundColor: color }}
      title={`${label}: ${val.toFixed(1)}`}
      data-testid={`score-seg-${label.toLowerCase()}`}
    />
  );

  return (
    <div className="w-full" data-testid="priority-score-bar">
      <div className="flex items-center gap-2">
        <div
          className="relative flex-1 rounded-full overflow-hidden bg-muted/70 ring-1 ring-border"
          style={{ height }}
        >
          <div className="flex h-full w-full">
            {seg(u, "hsl(var(--gold))", "Urgency")}
            {seg(m, "hsl(var(--success))", "Money")}
            {seg(c, "hsl(var(--info))", "Client")}
          </div>
        </div>
        <span className="font-mono-num text-sm font-semibold tabular w-9 text-right" style={{ color: scoreColor(total) }}>
          {total}
        </span>
      </div>
      {showLabels && (
        <div className="flex items-center gap-4 mt-2 text-[11px] text-muted-foreground">
          <Legend color="hsl(var(--gold))" label="Urgency" val={u} max={50} />
          <Legend color="hsl(var(--success))" label="Money" val={m} max={30} />
          <Legend color="hsl(var(--info))" label="Client" val={c} max={20} />
        </div>
      )}
    </div>
  );
}

function Legend({ color, label, val, max }) {
  return (
    <span className="flex items-center gap-1.5">
      <span className="inline-block w-2.5 h-2.5 rounded-sm" style={{ backgroundColor: color }} />
      <span>{label}</span>
      <span className="font-mono-num text-foreground/80">{val.toFixed(0)}/{max}</span>
    </span>
  );
}

function scoreColor(total) {
  if (total >= 85) return "hsl(var(--critical))";
  if (total >= 60) return "hsl(var(--warning))";
  return "hsl(var(--foreground))";
}
